import { Breakpoints, styled } from '@vw-marketing/us-components';

export const InputZipWrapper: any = styled.div`
  display: inline-table;
  width: 100%;
`;

export const InputContainer: any = styled.div`
  padding: 15px 0 10px 0;
  @media (min-width: ${Breakpoints.b960}px) {
    padding: 4px 0 10px 0;
  }
`;
export const SubmitButtonWrapper: any = styled.div`
  padding-top: 30px;
  @media (min-width: ${Breakpoints.b960}px) {
    padding-top: 26px;
  }
`;
